/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: "/dashboard",
    name: "Dashboard",
    view: "Dashboard/View",
    meta: { layout: "view" },
  },
  {
    path: "/whitelabels",
    name: "White Labels",
    view: "WhiteLabel/List",
    meta: { layout: "view" },
  },
  {
    path: "/whitelabel/create",
    name: "New White Label",
    view: "WhiteLabel/NewOrEdit",
    meta: { layout: "view" },
  },
  {
    path: "/whitelabel/:uuid/edit",
    name: "Edit White Label",
    view: "WhiteLabel/NewOrEdit",
    meta: { layout: "view" },
  },
  {
    path: "/users",
    name: "Users",
    view: "Users/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/strategies",
    name: "Strategies",
    view: "Modules/SpotFutures/Strategies/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/strategy/:id/view",
    name: "Strategy",
    view: "Modules/SpotFutures/Strategies/View",
    meta: { layout: "view" },
  },
  {
    path: "/modules/strategy/create",
    name: "New Strategy",
    view: "Modules/SpotFutures/Strategies/NewOrEdit",
    meta: { layout: "view" },
  },
  {
    path: "/modules/strategy/:id/edit",
    name: "Edit Strategy",
    view: "Modules/SpotFutures/Strategies/NewOrEdit",
    meta: { layout: "view" },
  },
  {
    path: "/modules/linkedaccounts",
    name: "Linked Accounts",
    view: "Modules/SpotFutures/LinkedAccounts/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/connection/:id",
    name: "Investor Details",
    view: "Modules/SpotFutures/Connections/View",
    meta: { layout: "view" },
  },
  {
    path: "/withdrawals",
    name: "Withdrawals",
    view: "Withdrawals/List",
    meta: { layout: "view" },
  },
  {
    path: "/transactions",
    name: "Transactions",
    view: "Transactions/List",
    meta: { layout: "view" },
  },
  {
    path: "/invoices",
    name: "Invoices",
    view: "Invoices/List",
    meta: { layout: "view" },
  },
  {
    path: "/myinvoices",
    name: "My Invoices",
    view: "MyInvoices/List",
    meta: { layout: "view" },
  },
  {
    path: "/tariffs",
    name: "Tariffs",
    view: "Tariffs/List",
    meta: { layout: "view" },
  },
  {
    path: "/affplans",
    name: "Affiliate Plans",
    view: "AffiliatePlans/List",
    meta: { layout: "view" },
  },
  {
    path: "/invoice/:id",
    name: "View Invoice",
    view: "Invoices/View",
    meta: { layout: "view" },
  },
  {
    path: "/myinvoice/:id",
    name: "View  My Invoice",
    view: "MyInvoices/View",
    meta: { layout: "view" },
  },
  {
    path: "/thankyou/:id?",
    name: "ThankYou",
    view: "MyInvoices/ThankYou",
    meta: { layout: "view" },
  },
  {
    path: "/profile",
    name: "Profile",
    view: "Profile/Profile",
    meta: { layout: "view" },
  },
  {
    path: "/security",
    name: "Security",
    view: "Security/View",
    meta: { layout: "view" },
  },
  {
    path: "/members",
    name: "Members",
    view: "Members/Members",
    meta: { layout: "view" },
  },

  // Modules
  {
    path: "/modules/configuration",
    name: "Configuration",
    view: "Modules/Configuration/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/staking",
    name: "Staking",
    view: "Modules/Staking/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/products",
    name: "Products",
    view: "Modules/Products/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/investplans",
    name: "Investments",
    view: "Modules/Investments/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/promocodes",
    name: "PromoCodes",
    view: "Modules/PromoCodes/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/realestatedeals",
    name: "Deals",
    view: "Modules/Deals/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/cms",
    name: "CMS",
    view: "Modules/Cms/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/roadmap",
    name: "RoadMap",
    view: "Modules/RoadMap/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/defi",
    name: "DeFi Modules",
    view: "Modules/DefiModules/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/ito",
    name: "ITO",
    view: "Modules/Ito/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/crowdfunding",
    name: "Crowdfunding",
    view: "Modules/Crowdfunding/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/lms",
    name: "LMS",
    view: "Modules/Lms/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/licenses",
    name: "Licenses",
    view: "Modules/Licenses/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/bulkpayouts",
    name: "BulkPayouts",
    view: "Modules/BulkPayouts/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/raffle",
    name: "Raffle",
    view: "Modules/Lotteries/List",
    meta: { layout: "view" },
  },
  // Game Routes
  {
    path: "/modules/clicker-game/earns",
    name: "Earns",
    view: "Modules/Game/Earns/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/clicker-game/boosters",
    name: "Boosters",
    view: "Modules/Game/Boosters/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/clicker-game/charities",
    name: "Charities",
    view: "Modules/Game/Charities/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/clicker-game/promo-codes-swap",
    name: "PromoCodeSwap",
    view: "Modules/Game/PromoCodeSwap/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/clicker-game/airdrops",
    name: "Airdrops",
    view: "Modules/Game/Airdrops/List",
    meta: { layout: "view" },
  },
  {
    path: "/modules/clicker-game/airdrops/create",
    name: "New Airdrop",
    view: "Modules/Game/Airdrops/NewOrEditForm",
    meta: { layout: "view" },
  },
  {
    path: "/modules/clicker-game/airdrops/:uuid",
    name: "Edit Airdrop",
    view: "Modules/Game/Airdrops/NewOrEditForm",
    meta: { layout: "view" },
  },
  // Digital Contracts
  {
    path: "/modules/digital-contracts",
    name: "Digital Contracts",
    view: "Modules/DigitalContracts/List",
    meta: { layout: "view" },
  },
  // Trading Portfolio
  {
    path: "/modules/trading-portfolio",
    name: "Trading Portfolio",
    view: "Modules/TradingPortfolio/Dashboard/View",
    meta: { layout: "view" },
  },
  // Gateways
  {
    path: "/gateways",
    name: "Gateways",
    view: "Gateways/List",
    meta: { layout: "view" },
  },
  // Auth Routes

  {
    path: "/register/:id?",
    name: "Register",
    view: "Auth/Register",
    meta: { layout: "view-auth" },
  },
  {
    path: "/verifyemail/:id",
    name: "Verify Email",
    view: "Auth/VerifyEmail",
    meta: { layout: "view-auth" },
  },
  {
    path: "/login",
    name: "Login",
    view: "Auth/Login",
    meta: { layout: "view-auth" },
  },
  {
    path: "/quiz",
    name: "Quiz",
    view: "Auth/Quiz",
    meta: { layout: "view-auth" },
  },
  {
    path: "/logout",
    name: "Logout",
    view: "Auth/Logout",
    meta: { layout: "view-auth" },
  },
  {
    path: "/resetpassword",
    name: "ResetPassword",
    view: "Auth/ResetPassword",
    meta: { layout: "view-auth" },
  },
  {
    path: "/newpassword/:id",
    name: "NewPassword",
    view: "Auth/NewPassword",
    meta: { layout: "view-auth" },
  },
];
